import React, { useState } from 'react';
import { COLUMNS, PRIORITIES, LABELS } from './taskData';

function TaskForm({ task, onSave, onClose }) {
  const isEditing = !!task;
  const [title, setTitle] = useState(task?.title || '');
  const [description, setDescription] = useState(task?.description || '');
  const [column, setColumn] = useState(task?.column || 'todo');
  const [priority, setPriority] = useState(task?.priority || 'medium');
  const [selectedLabels, setSelectedLabels] = useState(task?.labels || []);
  const [subtasks, setSubtasks] = useState(task?.subtasks || []);
  const [newSubtask, setNewSubtask] = useState('');

  const toggleLabel = (labelId) => {
    setSelectedLabels((prev) =>
      prev.includes(labelId) ? prev.filter((l) => l !== labelId) : [...prev, labelId]
    );
  };

  const addSubtask = () => {
    if (!newSubtask.trim()) return;
    setSubtasks([...subtasks, { id: Date.now().toString(), text: newSubtask.trim(), done: false }]);
    setNewSubtask('');
  };

  const removeSubtask = (id) => {
    setSubtasks(subtasks.filter((s) => s.id !== id));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    onSave({
      ...(task || {}),
      title: title.trim(),
      description: description.trim(),
      column,
      priority,
      labels: selectedLabels,
      subtasks,
    });
  };

  return (
    <div className="tm-modal-overlay" onClick={onClose}>
      <div className="tm-form-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tm-form-header">
          <h2>{isEditing ? 'Edit Task' : 'Create New Task'}</h2>
          <button className="tm-modal-action-btn" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="tm-form">
          <div className="tm-form-group">
            <label>Title *</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Task title..."
              autoFocus
              required
            />
          </div>

          <div className="tm-form-group">
            <label>Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Add a description..."
              rows={3}
            />
          </div>

          <div className="tm-form-row">
            <div className="tm-form-group">
              <label>Column</label>
              <select value={column} onChange={(e) => setColumn(e.target.value)}>
                {Object.values(COLUMNS).map((col) => (
                  <option key={col.id} value={col.id}>{col.icon} {col.title}</option>
                ))}
              </select>
            </div>
            <div className="tm-form-group">
              <label>Priority</label>
              <select value={priority} onChange={(e) => setPriority(e.target.value)}>
                {Object.entries(PRIORITIES).map(([key, p]) => (
                  <option key={key} value={key}>{p.icon} {p.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="tm-form-group">
            <label>Labels</label>
            <div className="tm-form-labels">
              {LABELS.map((label) => (
                <button
                  key={label.id}
                  type="button"
                  className={`tm-form-label-btn ${selectedLabels.includes(label.id) ? 'active' : ''}`}
                  style={{
                    '--label-color': label.color,
                    background: selectedLabels.includes(label.id) ? label.color + '33' : 'transparent',
                    borderColor: selectedLabels.includes(label.id) ? label.color : 'var(--border)',
                    color: selectedLabels.includes(label.id) ? label.color : 'var(--text-secondary)',
                  }}
                  onClick={() => toggleLabel(label.id)}
                >
                  {label.name}
                </button>
              ))}
            </div>
          </div>

          <div className="tm-form-group">
            <label>Subtasks</label>
            <div className="tm-form-subtask-input">
              <input
                type="text"
                value={newSubtask}
                onChange={(e) => setNewSubtask(e.target.value)}
                placeholder="Add a subtask..."
                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addSubtask())}
              />
              <button type="button" onClick={addSubtask} className="tm-form-subtask-add">+</button>
            </div>
            {subtasks.length > 0 && (
              <ul className="tm-form-subtask-list">
                {subtasks.map((sub) => (
                  <li key={sub.id} className="tm-form-subtask-item">
                    <span className={sub.done ? 'done' : ''}>{sub.text}</span>
                    <button type="button" onClick={() => removeSubtask(sub.id)} className="tm-form-subtask-remove">
                      &times;
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="tm-form-footer">
            <button type="button" className="tm-form-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="tm-form-submit">
              {isEditing ? 'Update Task' : 'Create Task'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default TaskForm;
